export default "__VITE_ASSET__Bf8d$ml0__"